<template>
    <v-content v-if="$store.state.org">
        <v-container v-if="!thankyou">
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md8 offset-md1 class="text-xs-center text-md-center">
                        <img :src="$store.state.org.Item.info.small_logo" height="60" />
                        {{orgkey}}
                    </v-flex>
                    <v-flex xs12 sm6 md8 offset-md1 class="text-xs-center">
                        <h2>Scottsdale BeachFest Volunteer Registration</h2>
                    </v-flex>
                    <v-flex xs12 sm6 md3 offset-md2 class="pl-3">
                        <v-text-field
                                label="Firstname"
                                v-model="firstname"
                                outline
                                required
                                :rules="nameRules"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="pl-3">
                        <v-text-field
                                label="Lastname"
                                v-model="lastname"
                                outline
                                required
                                :rules="nameRules"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6 offset-md2 class="pl-3">
                        <v-text-field
                                label="Mobile"
                                outline
                                v-model="cell"
                                required
                                counter="10"
                                :rules="cellRules"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="pl-3">
                        <v-checkbox
                                :label="`OK to text ` + cell"
                                v-model="oktotext"
                                required
                                :rules="[v => !!v || 'Must approve for texting']"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm8 md6 offset-md2 class="pl-3">
                        <v-text-field
                                label="Email"
                                outline
                                v-model="email"
                                :rules="emailRules"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="pl-3">
                        <v-checkbox
                                :label="`OK to email ` + email"
                                v-model="oktoemail"
                                :rules="[v => !!v || 'Must approve for email']"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm8 md6 offset-md2 class="pl-3">
                        <v-select outline label="Desired Committee" v-model="committee" :items="items" ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md6 offset-md2 class="pl-3">
                        <v-btn :disabled="!valid"  outline color="success" @click="submit">Submit</v-btn>
                        <v-btn  outline color="success" @click="thankyou = true;" >Cancel</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>

        <v-dialog v-model="confirmeddialog" max-width="400">
            <v-card>
                <v-card-text>
                    <div class="text-xs-center">
                        <h2 class="font-weight-light mb-4">Confirmed cell for SMS </h2>
                        <v-icon color="blue" style="transform: scale(2);">sms</v-icon>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn flat @click="confirmeddialog=false, $router.push('/')">OK!</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
   </v-content>
</template>

<script>
    export default {
        data: () => ({
            items: ['Build Crew', 'Court Maintenance','Beachfest Store','Registration','Marketing','Signage'],
            function () {
                return {
                    valid:false,
                    firstname:'',
                    lastname:'',
                    cell:'',
                    email:'',
                    oktotext:true,
                    oktoemail:true,
                    orgname:'',
                    orgkey:'scottsdalebeachfest',
                    nameRules:[ v => !!v || 'Required'],
                    emailRules: [v => /.+@.+/.test(v) || 'E-mail must be valid'],
                    cellRules: [v => (v && v.length == 10) || 'Cell must be 10 characters'],
                    thankyou:false,
                    code:'',
                    error:'',
                    confirmeddialog:false,
                }
            }
        }),
        name: "Subscribe",
        mounted () {
            this.uuidcode = window.localStorage.getItem('textappyconfirmuuid');
        },
        methods: {
            submit: function(){
                if (this.$refs.form.validate()) {
                    let data = {
                        name: this.firstname + ' ' + this.lastname,
                        cell:this.cell,
                        email:this.email,
                        oktotext:this.oktotext,
                        oktoemail:this.oktoemail,
                        orgpartkey:this.orgkey,
                        committee:this.committee,
                        selfadded:1
                    }

                    let em = this
                    let options = {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    }
                    fetch(this.$store.state.url+'api/mobile/sbfvolunteer', options)
                        .then(res => res.json())
                        .then(function (res) {
                            //window.localStorage.setItem('textappyconfirmuuid',res.uuid)
                            em.thankyou = true;
                            em.firstname='';
                            em.lastname='';
                            em.cell='';
                            em.email='';
                            em.oktotext=false;
                            em.oktoemail=false;
                            em.valid = false;
                        })
                }

            },
        }
    }
</script>

<style scoped>

</style>